var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller("machinesController", [
    "$scope", "$rootScope", "machinesService", "$interval",
    function ($scope, $rootScope, machinesService, $interval) {

        $rootScope.activeBannerIndex = 0;
        $rootScope.activeAdIndex = 0;

        $scope.onBannerClick = function (index) {
            if ($scope.banners && $scope.banners.length > 0) {
                $rootScope.activeBannerIndex = index;
            } else {
                $rootScope.activeBannerIndex = 0;
            }
        };

        $scope.getMachinesPageContent = function () {
            machinesService.getMachinesPageContent().then(
                function (response) {
                    if (response && response.data) {
                        $scope.banners = response.data.banners;
                        $scope.bundleContent = response.data.bundle_content;
                        $scope.shop_category = response.data.shop_category;
                        $scope.shop_brands = response.data.shop_brands;
                        $scope.machine_condition = response.data.machine_condition;
                        $scope.all_machines = response.data.all_machines;
                        $scope.shop_hoop = response.data.hoop_size;
                        $scope.shop_type = response.data.shop_type;
                        $scope.projectAds = response.data.next_project;
                        $rootScope.activeBannerIndex = 0;
                        $scope.carousalInterval = setInterval(function () {
                            if ($scope.banners && $scope.banners.length > 0) {
                                $rootScope.activeBannerIndex = ($rootScope.activeBannerIndex + 1) % $scope.banners.length;
                            }
                        }, 5000);
                    }
                }
            );
        };

        $scope.getMachinesPageContent();
    }
]);
